module.exports = __webpack_public_path__ + "static/6324-e3425b048648b6402183895629d8dfc7.png";